import React, { useEffect, useMemo, useState } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import {
  BackButton,
  CancelButton,
  SaveButton,
} from "../../components/common/MainButtonComponent";
import ContentWrapper from "../../components/common/AssessmentContentWrapper";
import { routes } from "../../helper/routes";
import "./AssessShared.css";
import "./SetupAssessment.css";

export default function SetupAssessmentSectionEditPage({
  part: providedPart,
  section: providedSection,
  setOpenSectionEdit,
  editDetails,
  // notationOptions = [],
}) {

  const history = useHistory();
  const location = useLocation();
  const { id, sectionId } = useParams();
  const section = location.state?.section;
  const part = location.state?.part;
  const activeSection = providedSection || section;
  const activePart = providedPart || part;
  const fallbackTitle = useMemo(
    () =>
      `Section ${String(sectionId || "").replace("section-", "") || "Details"}`,
    [sectionId]
  );

  const [title, setTitle] = useState(activeSection?.title || fallbackTitle);
  const [displayOrder, setDisplayOrder] = useState(activeSection?.displayOrder || "1");
  const [notation, setNotation] = useState(activeSection?.notation || "");
  const [notationId, setNotationId] = useState(activeSection?.notationId ?? null);
  const [allowOptionalQuestions, setAllowOptionalQuestions] = useState(Boolean(activeSection?.allowOptionalQuestions ?? false));
  const [requiredQuestionsCount, setRequiredQuestionsCount] = useState(String(activeSection?.requiredQuestionsCount ?? ""));
  const [questionsToAnswerCount, setQuestionsToAnswerCount] = useState(String(activeSection?.questionsToAnswerCount ?? ""));
  const [allowInstructions, setAllowInstructions] = useState(Boolean(activeSection?.allowInstructions ?? false));
  const [instructions, setInstructions] = useState(activeSection?.instructions || "Add instructions for this section here.");

  // const normalizedNotationOptions = useMemo(() => {
  //   if (!Array.isArray(notationOptions)) return [];
  //   return notationOptions
  //     .map((opt) => {
  //       if (!opt) return null;
  //       const id = opt.value ?? opt.notation_id ?? opt.id ?? opt.notationId ?? null;
  //       const label = opt.label ?? opt.notation_type ?? opt.name ?? opt.notation ?? null;
  //       if (id == null && label == null) return null;
  //       return { id: String(id ?? label), label: String(label ?? id) };
  //     })
  //     .filter(Boolean);
  // }, [notationOptions]);

  // const selectedNotationValue = notationId != null ? String(notationId) : notation;

  useEffect(() => {
    setTitle(activeSection?.title || fallbackTitle);
    setDisplayOrder(activeSection?.displayOrder || "1");
    // setNotation(activeSection?.notation || "");
    // setNotationId(activeSection?.notationId ?? null);
    setAllowOptionalQuestions(
      Boolean(activeSection?.allowOptionalQuestions ?? false)
    );
    setRequiredQuestionsCount(
      String(activeSection?.requiredQuestionsCount ?? "")
    );
    setQuestionsToAnswerCount(
      String(activeSection?.questionsToAnswerCount ?? "")
    );
    setAllowInstructions(
      Boolean(activeSection?.allowInstructions ?? false)
    );
    setInstructions(
      activeSection?.instructions || "Add instructions for this section here."
    );
  }, [activeSection, fallbackTitle]);

  // useEffect(() => {
  //   if (!normalizedNotationOptions.length) return;

  //   if (notationId != null) {
  //     const found = normalizedNotationOptions.find((o) => String(o.id) === String(notationId));
  //     if (found && found.label !== notation) setNotation(found.label);
  //     return;
  //   }

  //   if (notation) {
  //     const found = normalizedNotationOptions.find((o) => String(o.label) === String(notation));
  //     if (found) setNotationId(found.id);
  //     return;
  //   }
  // }, [normalizedNotationOptions, notationId, notation]);


  const goBack = () => {
    if (typeof setOpenSectionEdit === "function") {
      setOpenSectionEdit(null);
      return;
    }

    history.push(`${routes.asses_lib}/setup/${id}`);
  };

  const updateSection = async () => {
    const payload = {
      partId: activePart?.id,
      partAssessmentId: activePart?.assessmentPartId,
      sectionId: activeSection?.id,
      assessmentSectionId: activeSection?.assessmentSectionId,
      // notationId: notationId ?? activeSection?.notationId ?? null,
      title,
      // displayOrder: Number(displayOrder) || 1,
      // notation,
      questionsCount: activeSection?.questions?.length ?? 0,
      allowOptionalQuestions,
      requiredQuestionsCount: Number(requiredQuestionsCount) || 0,
      questionsToAnswerCount: Number(questionsToAnswerCount) || 0,
      allowInstructions,
      instructions,
    };
    if (typeof editDetails === "function") {
      await editDetails(payload);
      return;
    }

    goBack();
  };

  return (
    <ContentWrapper>
      <section className="assess-section setup-meta-page">
        <div className="setup-meta-page__actions">
          <BackButton label="Back" onClick={goBack} />
        </div>

        <div className="setup-meta-card">
          <div className="setup-meta-card__header">
            <h1>Update Section &apos;{title}&apos; Details</h1>
          </div>

          <div className="setup-meta-card__body">
            <div className="row g-3">
              <div className="col-12">
                <label className="setup-meta-field">
                  <span>Section Title *</span>
                  <input
                    value={title}
                    onChange={(event) => setTitle(event.target.value)}
                  />
                </label>
              </div>

              <div className="col-12 col-lg-6">
                <label className="setup-meta-field">
                  <span>Display Order</span>
                  <input
                    type="number"
                    // min="1"
                    value={displayOrder}
                    // onChange={(event) => setDisplayOrder(event.target.value)}
                    disabled
                    readOnly
                  />
                </label>
              </div>

              <div className="col-12 col-lg-6">
                <label className="setup-meta-field">
                  <span>No of Questions *</span>
                  <input
                    type="number"
                    min="0"
                    value={activeSection?.questions?.length ?? 0}
                    readOnly
                  />
                </label>
              </div>

              {/* <div className="col-12">
                <label className="setup-meta-field">
                  <span>Select Notation</span>
                  <select
                    value={selectedNotationValue}
                    onChange={(event) => {
                      const val = event.target.value;
                      // prefer matching by id
                      const foundById = normalizedNotationOptions.find((o) => String(o.id) === String(val));
                      if (foundById) {
                        setNotationId(foundById.id);
                        setNotation(foundById.label);
                        return;
                      }
                      // fallback: try matching by label
                      const foundByLabel = normalizedNotationOptions.find((o) => String(o.label) === String(val));
                      if (foundByLabel) {
                        setNotationId(foundByLabel.id);
                        setNotation(foundByLabel.label);
                        return;
                      }
                      // last fallback: set notation string
                      setNotation(val);
                      setNotationId(null);
                    }}
                  >
                    {normalizedNotationOptions.length > 0
                      ? normalizedNotationOptions.map((opt) => (
                          <option key={opt.id} value={opt.id}>
                            {opt.label}
                          </option>
                        ))
                      : (
                       null
                      )}
                  </select>
                </label>
              </div> */}

              <div className="col-12">
                <label className="setup-meta-check">
                  <input
                    type="checkbox"
                    checked={allowOptionalQuestions}
                    onChange={(event) =>
                      setAllowOptionalQuestions(event.target.checked)
                    }
                  />
                  <span>Allow Optional Questions</span>
                </label>
              </div>

              {allowOptionalQuestions ? (
                <>
                  <div className="col-12 col-lg-6">
                    <label className="setup-meta-field">
                      <span>Number of Required Questions *</span>
                      <input
                        type="number"
                        min="0"
                        value={requiredQuestionsCount}
                        onChange={(event) =>
                          setRequiredQuestionsCount(event.target.value)
                        }
                      />
                    </label>
                  </div>

                  <div className="col-12 col-lg-6">
                    <label className="setup-meta-field">
                      <span>Number of Questions to Answer *</span>
                      <input
                        type="number"
                        min="0"
                        value={questionsToAnswerCount}
                        onChange={(event) =>
                          setQuestionsToAnswerCount(event.target.value)
                        }
                      />
                    </label>
                  </div>
                </>
              ) : null}

              <div className="col-12">
                <label className="setup-meta-check">
                  <input
                    type="checkbox"
                    checked={allowInstructions}
                    onChange={(event) =>
                      setAllowInstructions(event.target.checked)
                    }
                  />
                  <span>Allow Section Instructions</span>
                </label>
              </div>

              {allowInstructions ? (
                <div className="col-12">
                  <label className="setup-meta-field">
                    <span>Section Instructions *</span>
                    <textarea
                      rows="7"
                      value={instructions}
                      onChange={(event) => setInstructions(event.target.value)}
                    />
                  </label>
                </div>
              ) : null}
            </div>
          </div>

          <div className="setup-meta-card__footer">
            <CancelButton label="Cancel" onClick={goBack} />
            <SaveButton label="Update" onClick={updateSection} />
          </div>
        </div>
      </section>
    </ContentWrapper>
  );
}
